import { createReactBlockSpec } from "@blocknote/react";
import classNames from "classnames";
import { positionStyles } from "ui";

export const DividerBlockSpec = createReactBlockSpec(
  {
    type: "dividerBlock",
    propSchema: {},
    content: "none",
    isSelectable: true,
  },
  {
    render: () => {
      return (
        <div className={classNames(positionStyles.relative, positionStyles.extraHover)}>
          <hr />
        </div>
      );
    },
    toExternalHTML: () => {
      return <hr />;
    },
  },
);
